import { Fragment } from 'react';
import UserFifthProfile from './UserFifthProfile';
import UserFirstProfile from './UserFirstProfile';
import UserFourthProfile from './UserFourthProfile';
import UserSecondProfile from './UserSecondProfile';
import UserThirdProfile from './UserThirdProfile';

export default function TourMain() {
  return (
    <Fragment>
      <UserFirstProfile />
      <UserSecondProfile />
      <UserThirdProfile />
      <UserFourthProfile />
      <UserFifthProfile />
    </Fragment>
  );
}
